import React from 'react';

export const MessagingSignatureDescription = (
  <p className="vads-u-margin-bottom--2">
    <strong>Both fields are required to save a signature.</strong>
  </p>
);
